import { Component, OnInit } from "@angular/core";
import { SetupWizardService } from "@services/setup-wizard.service";

@Component({
  selector: "app-wizard-integrations",
  templateUrl: "./wizard-integrations.component.html",
  styleUrls: ["./wizard-integrations.component.scss", "../wizard-styles.scss"],
})
export class WizardIntegrationsComponent implements OnInit {
  public processingIntegrations$;
  constructor(private wizardService: SetupWizardService) {}
  ngOnInit(): void {}
}
